<!-- eslint-disable vue/no-multiple-template-root -->
<template>
    <template v-if="show">
        <slot />
    </template>
</template>

<script setup>
import { ref, onMounted } from 'vue';

defineOptions({ name: 'AClientOnly' });

const show = ref(false);
onMounted(() => {
    show.value = true;
});
</script>
